<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {};
</script>
<style>
@import "./style/style.css";
body, html{
   padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100%;
}
</style>

